module.exports = __webpack_public_path__ + "media/images/lb/955-34f3ec283d30f58a1ba15c24d71d0f23.svg";